const WA_LINK = "https://wa.link/szf6pp";

const steps = [
  {
    num: "01",
    icon: "ri-whatsapp-line",
    title: "Escríbenos por WhatsApp",
    desc: "Contáctanos directamente al número de WhatsApp. Sin formularios, sin esperas.",
  },
  {
    num: "02",
    icon: "ri-car-line",
    title: "Envía VIN o modelo",
    desc: "Comparte el número de matrícula (VIN) o el modelo y año de tu vehículo.",
  },
  {
    num: "03",
    icon: "ri-customer-service-2-line",
    title: "Recibe asesoría inmediata",
    desc: "Nuestros expertos te identifican el repuesto exacto y te dan la cotización.",
  },
  {
    num: "04",
    icon: "ri-truck-line",
    title: "Envío a tu ciudad",
    desc: "Confirmado el pedido, despachamos a cualquier ciudad de Colombia.",
  },
];

export default function ConversionSection() {
  return (
    <>
      {/* Conversion CTA */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#E10600] via-[#c00000] to-[#8b0000]"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full translate-y-1/2 -translate-x-1/2"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
          <span className="text-white/70 text-xs font-black uppercase tracking-widest mb-4 block">
            Cotización rápida
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight">
            ¿Necesitas un repuesto específico?
          </h2>
          <p className="text-white/85 text-base md:text-xl leading-relaxed mb-8 max-w-2xl mx-auto">
            Podemos ayudarte incluso si el repuesto no se encuentra en el mercado colombiano. Importamos piezas y procuramos compatibilidad.
          </p>

          {/* Instruction box */}
          <div className="bg-white/15 border-2 border-white/30 rounded-xl p-6 mb-10 max-w-2xl mx-auto">
            <div className="flex items-start gap-3 text-left">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div>
                <p className="text-white font-bold text-base mb-1">¿Cómo cotizar?</p>
                <p className="text-white/80 text-sm leading-relaxed">
                  Envíanos la foto de la matrícula con el número VIN. Con esa información te damos la cotización exacta.
                </p>
                <div className="mt-3 bg-black/20 rounded-lg px-4 py-2 text-white/90 text-sm font-mono">
                  "Hola, necesito un repuesto para Mitsubishi. Mi VIN es: ______ y busco: ______"
                </div>
              </div>
            </div>
          </div>

          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-3 bg-white text-[#E10600] font-black text-lg md:text-xl px-10 py-5 rounded-full hover:scale-105 transition-all duration-200 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl text-green-500"></i>
            Cotizar ahora por WhatsApp
          </a>
        </div>
      </section>

      {/* How to buy */}
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-14">
            <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-3 block">
              Proceso simple
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black">
              ¿Cómo comprar?
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {/* Connector line (desktop) */}
            <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-0.5 border-t-2 border-dashed border-[#E10600]/30 z-0"></div>

            {steps.map((step, idx) => (
              <div key={step.num} className="relative z-10 flex flex-col items-center text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-[#E10600] rounded-full mb-5 shadow-lg shadow-red-200">
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                <div className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-2">Paso {idx + 1}</div>
                <h3 className="text-black font-black text-base mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
